<article class="post-card" [attr.aria-label]="post.title">
  <div class="pc-community">
    <span class="comm-dot" [style.background]="communityPalette.primary"></span>
    <span
      class="comm-label"
      [style.color]="communityPalette.text"
      [style.background]="communityPalette.bg"
      [style.border-color]="communityPalette.border"
    >
      {{ displayCommunityName }}
    </span>
  </div>

  <div class="pc-body">
    <h4 class="pc-title">{{ post.title }}</h4>
    <p class="pc-excerpt" [class.clipped]="!expanded">{{ post.excerpt }}</p>
    <button type="button" class="read-more-btn" (click)="toggleExcerpt()">
      {{ expanded ? 'Show less' : 'Read more' }}
    </button>
  </div>

  <footer class="pc-footer">
    <div class="pc-stats">
      <span>{{ resolvedReplyCount ?? post.replyCount ?? 0 }} replies</span>
      <span>{{ resolvedHelpfulReplyCount ?? post.helpfulReplyCount ?? 0 }} helpful</span>
    </div>
    <button
      type="button"
      class="view-btn"
      [disabled]="opening"
      (click)="openPost()"
      [attr.aria-label]="'View post: ' + post.title + ' and its replies'"
    >
      {{ opening ? 'Opening...' : 'View Post' }}
    </button>
  </footer>
</article>
